import request from '@/utils/request'

export function getLogs (params) {
  return request({
    url: '/operationLog',
    method: 'get',
    params
  })
}